import React from 'react'
import { IonItemDivider, IonLabel } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import AddBilling from '../addBillingInfo/AddBillingInfo.component'

const BillingMobile: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <IonItemDivider color='light' className='ion-padding'>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('fullChart.patient.InsuranceCMSAndOtherPaymentDetails')}
        </IonLabel>
      </IonItemDivider>
      <AddBilling />
    </>
  )
}

export default BillingMobile
